import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
  }

  body {
    font-family: "Inter", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 0.875rem;
    line-height: 1.5;
    background-color: #f5f7fa;
    color: rgba(0, 0, 0, 0.87);
    margin: 0;
    min-height: 100vh;
  }

  #root {
    min-height: 100vh;
  }

  a {
    text-decoration: none;
    color: #1565c0;
    transition: color 0.2s ease;
  }

  a:hover {
    color: #0d47a1;
    text-decoration: underline;
  }

  input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="hidden"]):not([type="range"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="image"]),
  textarea,
  select {
    font-family: inherit;
    font-size: 0.875rem;
  }

  button,
  .MuiButton-root {
    font-family: inherit;
  }
`;

export default GlobalStyle;
